<div
    [id]="id + '.' + filter.id"
    class="agpr-filterCheckboxes"
    [formGroup]="tagFilterForm"
>
    <agpr-filter-include-exclude
        [id]="id + '_' + filter.id + '_includeExclude'"
        formControlName="includeExclude"
    ></agpr-filter-include-exclude>
    <label
        class="agpr-filterCheckboxes-search"
    >
        <agpr-text-input
            [id]="id + '.' + filter.id + '.search'"
            icon="fa-regular fa-duotone fa-magnifying-glass"
            ariaLabel="Monitoring.tagFilter.searchTags"
            formControlName="searchBar"
        ></agpr-text-input>
    </label>
    <div class="agpr-filterCheckboxes-toggleContainer">
        <agpr-button
            [id]="id + '.' + filter.id + (anyOptionsSelected ? '.selectNone' : '.selectAll')"
            class="agpr-filterCheckboxes-allToggle"
            [style]="buttonTypes.link"
            [label]="(anyOptionsSelected ? 'selectNone' : 'selectAll') | localize"
            aria-live="polite"
            (click)="selectItems()"
        ></agpr-button>
    </div>
    <agpr-scroll-panel>
        <ul
            class="agpr-filterCheckboxes-list"
            [attr.aria-label]="'filter' | localize"
            formGroupName="optionForm"
        >
            <li
                *ngFor="let option of filteredOptions; let i = index"
                class="agpr-filterCheckboxes-item"
            >
                <agpr-checkbox
                    [id]="id + '_' + filter.id + '_checkbox_' + i"
                    class="agpr-filterCheckboxes-checkbox"
                    [name]="'filterCheckboxes-' + filter.id"
                    [label]="option.label"
                    [binary]="true"
                    [formControlName]="'option_' + option.value"
                >
                    <span
                        *ngIf="option.count || option.count === 0"
                        class="agpr-filterCheckboxes-itemCount"
                        [pTooltip]="option.count | number"
                    >
                        {{ option.count | significantDigits : 1}}
                    </span>
                </agpr-checkbox>
            </li>
        </ul>
        <ng-container *ngIf="showAllFilters">
            <div class="agpr-filterCheckboxes-divider"></div>
            <ul
                class="agpr-filterCheckboxes-list"
                [attr.aria-label]="'Monitoring.tagFilter.moreTags' | localize"
                formGroupName="moreOptionForm"
            >
                <li
                    *ngFor="let option of filteredMoreOptions; let i = index"
                    class="agpr-filterCheckboxes-item"
                >
                    <agpr-checkbox
                        [id]="id + '_' + filter.id + '_moreTagsCheckbox_' + i"
                        class="agpr-filterCheckboxes-checkbox"
                        [name]="'moreFilterCheckboxes-' + filter.id"
                        [label]="option.label"
                        [binary]="true"
                        [formControlName]="'moreOption_' + option.value"
                    ></agpr-checkbox>
                </li>
            </ul>
        </ng-container>
    </agpr-scroll-panel>
    <agpr-button
        *ngIf="filter.hasMoreOptions"
        class="agpr-filterCheckboxes-toggleShowAllFilterButton"
        [style]="buttonTypes.link"
        [label]="(showAllFilters ? 'Monitoring.tagFilter.hideAllFilters' : 'Monitoring.tagFilter.showAllFilters') | localize"
        (click)="toggleShowAllFilters()"
    >
        <span
            class="agpr-filterCheckboxes-toggleShowAllFilterButton-infoCircle fa-regular fa-circle-info"
            agprTooltip="Monitoring.tagFilter.toggleAllFilterTooltip"
            tooltipPosition="top"
        ></span>
    </agpr-button>
</div>